import React, { useEffect } from 'react';
import Logo1 from '../assets/Affeerce_Dino.jpg';
import '../App.css';

const Home = () => {
  useEffect(() => {
    // Ensure Facebook plugins render properly after component mounts
    if (window.FB) {
      window.FB.XFBML.parse();
    }
  }, []);

  return (
    <div className="home-container">
      <h1>Welcome to AFFEERCE</h1>
      <p>
        AFFEERCE is a new economic system that transitions from debt-based capitalism to land-based capitalism.
      </p>

      <div className="home-flex">
        <div className="logo-wrapper">
          <img
            src={Logo1}
            alt="AFFEERCE Banner"
            className="home-logo-img"
            style={{
              width: '110%',
              height: '11%',
            }}
          />
        </div>

        <div className="video-wrapper">
          <iframe
            width="460"
            height="260"
            src="https://www.youtube.com/embed/vXD2sW2G5Hs"
            title="AFFEERCE Intro Video"
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>
      </div>

      {/* Facebook Section */}
      <div className="facebook-section">
        <h2>Join the Conversation on Facebook</h2>
        <p>Like our page and connect with others shaping the future of AFFEERCE</p>

        <div className="facebook-like-wrapper">
          {/* Facebook Like Button */}
          <div
            className="fb-like"
            data-href="https://www.facebook.com/groups/AFFEERCE/"
            data-width=""
            data-layout="standard"
            data-action="like"
            data-size="large"
            data-share="true"
            data-show-faces="true"
          ></div>

          {/* Facebook Group Link Button */}
          <a
            className="facebook-button"
            href="https://www.facebook.com/groups/AFFEERCE/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Discuss AFFEERCE on Facebook
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;
